import InlineEdit from "@atlaskit/inline-edit";
import { ExtendedFieldProps } from "@atlaskit/inline-edit/dist/types/types";
import { FC } from "react";

import { Box } from "../../UI/Box";
import { TextField } from "../../UI/TextField";
import { COLOR_ATHENS_GRAY, COLOR_IRON, COLOR_COOL_GREY } from "../../constants/styles";
import { useInternalCommentsHandler } from "./useInternalCommentsHandler";
import { Skeleton } from "../../UI/Skeleton";

interface IProps {
  unitId: number;
  defaultValue: string | null;
  isDisabled?: boolean;
}

const editView = ({ errorMessage, ...fieldProps }: ExtendedFieldProps<string>) => (
  <TextField {...fieldProps} autoFocus height={40} />
);

const readView = (value: string | null = "") => () => (
  <Box
    px={1}
    minWidth={200}
    width="100%"
    height={40}
    display="flex"
    alignItems="center"
    bgcolor={COLOR_ATHENS_GRAY}
    border={`1px solid ${COLOR_IRON}`}
  >
    {value}
  </Box>
);

const disabledReadView = (value: string | null = "") => (
  <Box
    px={1}
    minWidth={200}
    width="100%"
    height={40}
    display="flex"
    alignItems="center"
    bgcolor={COLOR_ATHENS_GRAY}
    border={`1px solid ${COLOR_IRON}`}
    sx={{ color: COLOR_COOL_GREY, cursor: 'default' }}
  >
    {value}
  </Box>
);

export const UnitInternalCommentEdit: FC<IProps> = (props) => {
  const { handleUpdate, isLoading } = useInternalCommentsHandler(props.unitId);

  if (isLoading) {
    return <Skeleton variant="rectangular" height={40} width="100%" />;
  }

  if (props.isDisabled) {
    return disabledReadView(props.defaultValue);
  }

  return (
    <InlineEdit
      keepEditViewOpenOnBlur
      readViewFitContainerWidth
      editView={editView}
      onConfirm={handleUpdate}
      defaultValue={props.defaultValue}
      readView={readView(props.defaultValue)}
    />
  );
};
